/* Imágenes de tarjetas de producto: si una foto falla (CDN lento/red móvil), se reintenta sola hasta 3 veces con una versión más ligera. */
(function () {
  'use strict';
  if (window.__mfImg) return;
  window.__mfImg = true;
  var SEL = '.card-gallery img, .resource-card img, .product-card img, .product-media__image';

  function setWidth(u, w) {
    return /([?&])width=\d+/.test(u)
      ? u.replace(/([?&])width=\d+/, '$1width=' + w)
      : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function retry(img) {
    var n = +img.dataset.mfRetry || 0;
    if (n >= 3) return;
    img.dataset.mfRetry = String(n + 1);
    setTimeout(function () {
      var u = img.currentSrc || img.getAttribute('src') || '';
      if (!u) return;
      u = setWidth(u.split('#')[0], n === 0 ? 720 : 480);
      u += (u.indexOf('?') > -1 ? '&' : '?') + 'mfr=' + (n + 1);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = u;
    }, 400 * (n + 1) * (n + 1));
  }

  document.addEventListener(
    'error',
    function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.matches && t.matches(SEL)) retry(t);
    },
    true
  );
})();

/* Carrusel "Potrebbe piacerti anche": flechas circulares (Igor 2026-10-13). El CSS esta en assets/rendimiento-claude.css. */
(function () {
  'use strict';
  function setup(root) {
    var list = root.querySelector('.resource-list--grid');
    if (!list || list.__mfrc || list.querySelectorAll('.resource-list__item').length < 3) return;
    list.__mfrc = true;
    var host = list.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    function mk(c, d, p) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mfrc-ar ' + c; b.setAttribute('aria-label', d);
      b.innerHTML = '<svg viewBox="0 0 24 24"><path d="' + p + '"/></svg>';
      host.appendChild(b); return b;
    }
    var L = mk('mfrc-l', 'Precedente', 'm15 5-7 7 7 7'), R = mk('mfrc-r', 'Successivo', 'm9 5 7 7-7 7');
    function pos() {
      var h = (L.offsetParent || host).getBoundingClientRect(), l = list.getBoundingClientRect(), im = list.querySelector('.card-gallery') || list.querySelector('img');
      var ih = im ? im.getBoundingClientRect().height : 160, s = L.offsetWidth || 38, top = l.top - h.top + ih / 2 - s / 2;
      L.style.top = R.style.top = top + 'px';
      L.style.left = (l.left - h.left + 6) + 'px';
      R.style.left = (l.right - h.left - 6 - s) + 'px';
    }
    function upd() {
      var m = list.scrollWidth - list.clientWidth;
      L.disabled = list.scrollLeft < 4; R.disabled = list.scrollLeft > m - 4;
    }
    function go(d) {
      var c = list.querySelector('.resource-list__item');
      list.scrollBy({ left: d * (c.getBoundingClientRect().width + 12) * 2, behavior: 'smooth' });
    }
    L.addEventListener('click', function () { go(-1); });
    R.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', function () { pos(); upd(); });
    list.addEventListener('load', function () { pos(); }, true);
    pos(); upd(); setTimeout(pos, 600); setTimeout(pos, 1800);
  }
  function all() { document.querySelectorAll('product-recommendations').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
